
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import ConsumerConsumptionChart from '@/components/ConsumerConsumptionChart';

const ConsumptionTrendsCard: React.FC = () => {
  return (
    <Card className="shadow-md border-cyan-100 dark:border-cyan-900/50 bg-gradient-to-br from-white to-cyan-50/30 dark:from-gray-800 dark:to-cyan-950/10 overflow-hidden">
      <CardHeader className="pb-1 pt-3">
        <CardTitle className="text-lg font-semibold text-cyan-800 dark:text-cyan-300">Consumer Usage Trends</CardTitle>
        <CardDescription className="text-cyan-600/80 dark:text-cyan-400/80 text-xs">Monthly water consumption by consumer segment</CardDescription>
      </CardHeader>
      <CardContent className="p-3 overflow-hidden">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-3">
          <div className="bg-white/90 dark:bg-gray-800/60 p-2 rounded-lg shadow-sm border border-cyan-50 dark:border-cyan-900/30 h-52 overflow-hidden">
            <h3 className="text-xs font-medium mb-1 text-cyan-700 dark:text-cyan-300">Residential</h3>
            <div className="h-[calc(100%-1.25rem)] overflow-hidden">
              <ConsumerConsumptionChart userId="water-residential" className="h-full" />
            </div>
          </div>
          <div className="bg-white/90 dark:bg-gray-800/60 p-2 rounded-lg shadow-sm border border-cyan-50 dark:border-cyan-900/30 h-52 overflow-hidden">
            <h3 className="text-xs font-medium mb-1 text-cyan-700 dark:text-cyan-300">Commercial</h3>
            <div className="h-[calc(100%-1.25rem)] overflow-hidden">
              <ConsumerConsumptionChart userId="water-commercial" className="h-full" />
            </div>
          </div>
          <div className="bg-white/90 dark:bg-gray-800/60 p-2 rounded-lg shadow-sm border border-cyan-50 dark:border-cyan-900/30 h-52 overflow-hidden">
            <h3 className="text-xs font-medium mb-1 text-cyan-700 dark:text-cyan-300">Municipal</h3>
            <div className="h-[calc(100%-1.25rem)] overflow-hidden">
              <ConsumerConsumptionChart userId="water-municipal" className="h-full" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ConsumptionTrendsCard;
